import { render, staticRenderFns } from "./IseIadeAlacakForm.vue?vue&type=template&id=4d3820f9"
import script from "./IseIadeAlacakForm.vue?vue&type=script&lang=ts"
export * from "./IseIadeAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports